import { TuiTooltip } from '@taiga-ui/kit';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { WorkflowFormFieldOutputLinkPopulated } from '@features/requests/request-form/components/request-form-workflows/types';
import { TuiLink, TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'x-output-link-field',
  imports: [TuiLink, TuiTooltip, TuiIcon],
  templateUrl: './output-link-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class OutputLinkFieldComponent {
  field = input.required<WorkflowFormFieldOutputLinkPopulated>();
}
